<section class="chart-panel">
  <header class="cp__head">
    <div class="cp__title">
      <h2>{{ title() }}</h2>
      <span class="sub">{{ subtitle() }}</span>
    </div>

    <div class="cp__price">
      <b class="mono">{{ lastPriceLabel() }}</b>
      <span class="unit">{{ quoteSymbol() }}</span>
      @if (changeLabel(); as change) {
        <span
          class="cp__chg"
          [class.up]="changeUp()"
          [class.down]="!changeUp()"
        >
          {{ change }}
        </span>
      }
    </div>

    <span class="cp__sp"></span>

    @if (showToolbar()) {
      <div class="cp__tools">
        <div class="seg" role="group" aria-label="Chart timeframe">
          @for (interval of intervals; track interval.value) {
            <button
              type="button"
              [class.active]="intervalMs() === interval.value"
              [attr.aria-pressed]="intervalMs() === interval.value"
              (click)="onIntervalPick(interval.value)"
            >
              {{ interval.label }}
            </button>
          }
        </div>

        <div class="seg" role="group" aria-label="Chart type">
          @for (item of modes; track item.value) {
            <button
              type="button"
              [class.active]="mode() === item.value"
              [attr.aria-pressed]="mode() === item.value"
              (click)="setMode(item.value)"
            >
              {{ item.label }}
            </button>
          }
        </div>

        <button
          type="button"
          class="iconbtn"
          [class.on]="showVolume()"
          aria-label="Toggle volume"
          (click)="toggleVolume()"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 20V10M9 20V4M14 20v-7M19 20V8" />
          </svg>
        </button>

        <button
          type="button"
          class="iconbtn"
          aria-label="Fit all data"
          (click)="fitAll()"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
          </svg>
        </button>
      </div>
    }
  </header>

  @if (readoutBar(); as bar) {
    <div
      class="cp__ohlc mono"
      [class.up]="!bar.empty && bar.c >= bar.o"
      [class.down]="!bar.empty && bar.c < bar.o"
      [class.neutral-bar]="!!bar.empty"
    >
      <span
        >O<b>{{ priceLabel(bar.o) }}</b></span
      >
      <span
        >H<b>{{ priceLabel(bar.h) }}</b></span
      >
      <span
        >L<b>{{ priceLabel(bar.l) }}</b></span
      >
      <span
        >C<b>{{ priceLabel(bar.c) }}</b></span
      >
      <span class="neutral"
        >Vol<b>{{
          bar.empty ? '—' : volumeLabel(bar.v) + ' ' + quoteSymbol()
        }}</b></span
      >
      <span class="neutral"
        >Trades<b>{{ bar.empty ? '—' : (bar.trades | number) }}</b></span
      >
    </div>
  }

  <div class="cp__body">
    <div class="cp__canvas-host" #chartHost></div>

    @if (hasData()) {
      <div class="cp__pan">
        <button type="button" aria-label="Pan left" (click)="panLeft()">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 5l-7 7 7 7" />
          </svg>
        </button>
        <button type="button" aria-label="Pan right" (click)="panRight()">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    }

    <div class="cp__zoom">
      <button type="button" aria-label="Zoom in" (click)="zoomIn()">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 5v14M5 12h14" />
        </svg>
      </button>
      <button type="button" aria-label="Zoom out" (click)="zoomOut()">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" /></svg>
      </button>
      <button type="button" aria-label="Reset zoom" (click)="resetView()">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M21 12a9 9 0 1 1-3-6.7L21 7M21 4v3h-3" />
        </svg>
      </button>
    </div>

    @if (hasData()) {
      <p class="cp__hint">
        Scroll to zoom · drag or arrow keys to pan · double-click to reset
      </p>
    }

    @if (loading()) {
      <div class="cp__overlay">
        <span class="cp__spinner" aria-hidden="true"></span>
        <span>Loading candles</span>
      </div>
    }

    @if (!loading() && !hasData()) {
      <div class="cp__overlay">
        <span>No candle data for this trading mode.</span>
      </div>
    }
  </div>

  @if (hasData()) {
    <footer class="cp__foot">
      <span class="cp__dot" aria-hidden="true"></span>
      <span>Live · indexer synced</span>
      <span class="cp__sp"></span>
      <span
        >Visible <b class="mono">{{ visibleCount() }}</b> bars</span
      >
      <span
        >Vol <b class="mono">{{ totalVolumeLabel() }}</b>
        {{ quoteSymbol() }}</span
      >
      <span
        >Trades <b class="mono">{{ totalTrades() | number }}</b></span
      >
    </footer>
  }
</section>
